module.exports = __webpack_public_path__ + "static/w_howard-75f8d1cee95301e4b832e6ff961d91db.png";